import React from 'react'
import './Footer2.css'
import { Link } from 'react-router-dom'

function Footer2() {
  return (
    <div className="footer-area">
        <div className="container">
            <div className="col-md-12 col-sm-12 col-12">
                <hr/>
                <div className="footer">
                  <p>Copyright © 2024 <a href="#"> Risk Hub.</a></p>
                  {/* <div class="elfsight-app-711c42af-15df-4bcf-9b85-11c7b99d5565" data-elfsight-app-lazy></div> */}
                  <div className="footer-text">
                    <span><Link to='/terms-and-conditions'>Terms and Conditions</Link></span>
                    <span><Link to='/privacy-policy'>Privacy Policy</Link></span>
                    <span><Link to='/refund-and-cancellation'>Refund and Cancellation</Link></span>
                    {/* <span><div class="elfsight-app-711c42af-15df-4bcf-9b85-11c7b99d5565" data-elfsight-app-lazy></div></span> */}
                  </div>
                </div>
                <div style={{paddingBottom: "30px"}}></div>
            </div>
        </div>
    </div>
  )
}

export default Footer2